module.exports = __webpack_public_path__ + "img/531.fc8c9cbb.png";